import { MenuButton } from '@/components/MenuButton';
import { contactUs } from '@/utils';

export const Footer = () => {
  return (
    <footer
      id="Contacts"
      className="relative w-full rounded-t-[30px] bg-primary-primary-30-main px-6 py-10 shadow-[0px_-4px_90px_0px_rgba(0,0,0,0.1)] md:rounded-t-[60px] md:px-[53px] md:py-[62px]"
    >
      {/* Footer top section with logo and navigation */}
      <div className="flex flex-col items-center justify-between gap-8 md:flex-row md:gap-5">
        {/* Logo */}
        <div className="font-logo text-3xl text-white md:text-4xl">
          FURNITECH
        </div>

        {/* Navigation links */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
          <MenuButton title="Story" color="text-neutral-neutral-00" />
          <MenuButton title="Benefits" color="text-neutral-neutral-00" />
          <MenuButton title="Features" color="text-neutral-neutral-00" />
          <MenuButton title="Cases" color="text-neutral-neutral-00" />
        </div>
      </div>

      {/* Divider */}
      <div className="my-5 h-0 w-full border-t border-solid border-white md:my-6"></div>

      {/* Contact section */}
      <div className="flex justify-center md:justify-end">
        <button
          className="flex flex-row items-center gap-3 transition-opacity hover:opacity-80"
          onClick={contactUs}
          aria-label="Contact us by email"
        >
          <img
            className="h-5 w-5 md:h-6 md:w-6"
            src="quill-mail0.svg"
            alt="Email icon"
          />
          <div className="text-left font-subtitle-subtitle-3-font-family text-subtitle-subtitle-3-font-size font-subtitle-subtitle-3-font-weight uppercase leading-subtitle-subtitle-3-line-height text-neutral-neutral-00 decoration-dotted underline-offset-4 hover:underline">
            E-MAIL
          </div>
        </button>
      </div>
    </footer>
  );
};
